import SearchResultItem from "./SearchResultItem";
import "./SearchResultsList.scss";

const SearchResultsList = ({ searchTerm, searchResults }) => {

	return (
		<div className="searchResultsList">
			<SearchResultItem searchResults={searchResults} searchTerm={searchTerm}></SearchResultItem>
		</div>
	);
};

export default SearchResultsList;
